import { ts } from '_core';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.ALPHA_MODEL_AVERAGE_CORRELATION,
    title: 'Average correlation',
    helpLabel: 'xl5bqh4z',
    form: false,
    neededFiles: ['optimized_alpha_model_correlation'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL, ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL],
  },
] satisfies ts.types.analysis.WidgetConfig[];
